export default class GetTiposNovedad {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    return await this.#repository.getAllTipos()
  }
}
